module.exports = __webpack_public_path__ + "img/horizontal_6_6_8023.e657dedd.png";